import '../../../js/__utils/setPublicPath';
import React from 'react';
import { createRoot } from 'react-dom/client';
import ReactPlayer from 'react-player';
import getRemBase from '../../../js/__utils/getRemBase';

/**
 * Mounts a muted, autoplaying ReactPlayer into every background video wrapper on the page.
 */
const backgroundVideoComponent = () => {
	let backgroundVideos = [];

	/**
	 * Stores the block height so the CSS can size the video to cover the block.
	 *
	 * @param {HTMLElement} block The block containing the background video.
	 */
	const setBlockHeight = (block) => {
		block.style.setProperty(
			'--blockHeight',
			`${block.offsetHeight / getRemBase()}rem`
		);
	};

	const blockResizeObserver = new ResizeObserver((entries) => {
		entries.forEach((entry) => setBlockHeight(entry.target));
	});

	/**
	 * Fades the video in once the player is ready.
	 *
	 * @param {ReactPlayer} player The ready player instance.
	 */
	const videoLoaded = (player) => {
		player.wrapper.classList.add('loaded');
	};

	const loadVideos = () => {
		backgroundVideos = document.querySelectorAll(
			'.acf-block__background-video-wrapper'
		);

		if (backgroundVideos.length) {
			backgroundVideos.forEach((backgroundVideo) => {
				if (
					backgroundVideo.hasAttribute('data-video-url') &&
					!backgroundVideo.dataset.videoInitialized
				) {
					backgroundVideo.dataset.videoInitialized = 'true';

					const videoURL =
						backgroundVideo.getAttribute('data-video-url');
					const videoLoopAttribute =
						backgroundVideo.getAttribute('data-video-loop');
					const hideMobileBackgroundVideo =
						backgroundVideo.getAttribute('data-hide-mobile');
					const parentBlock = backgroundVideo.closest('.acf-block');
					let root = null;
					let videoLoop = true;

					if (
						'false' === videoLoopAttribute ||
						'0' === videoLoopAttribute
					) {
						videoLoop = false;
					}

					if (parentBlock) {
						setBlockHeight(parentBlock);
						blockResizeObserver.observe(parentBlock);
					}

					const renderVideo = () => {
						if (!root) {
							root = createRoot(backgroundVideo);
						}

						root.render(
							<ReactPlayer
								className="acf-block__background-video"
								url={videoURL}
								playing
								loop={videoLoop}
								muted
								onReady={(player) => {
									videoLoaded(player);
								}}
							/>
						);
					};

					const desktopQuery =
						window.matchMedia('(min-width: 992px)');

					if (hideMobileBackgroundVideo && !desktopQuery.matches) {
						const handleBreakpoint = (event) => {
							if (event.matches) {
								desktopQuery.removeEventListener(
									'change',
									handleBreakpoint
								);
								renderVideo();
							}
						};

						desktopQuery.addEventListener(
							'change',
							handleBreakpoint
						);
					} else {
						renderVideo();
					}
				}
			});
		}
	};

	loadVideos();
};

backgroundVideoComponent();

export default backgroundVideoComponent;
